import { Observable } from 'rxjs';

import { catchErrorLogRet } from '../../../common/rest.operators';
import { epicDependencies } from '../../../store';
import { Run, RunService } from '../../backend';

import { createParams } from './create-params.function';

export function createRun(): Observable<Run | null> {
    const runService = epicDependencies.injector.get<RunService>(RunService);

    const bp = createParams();
    const run: Run = {
        runId: null,
        parameters: JSON.stringify(bp),
        timestamp: null,
        createdBy: null,
        results: null,
    };

    return runService.create(run).pipe(catchErrorLogRet(null));
}
